export const formatSalary = (input) => {

  let output = input;
  const numbers = input.match(/(\d+.?\d+)/gm);

  for (let i = 0; i < numbers?.length; i++) {
    if (numbers[i] >= 1000) output = output.replace(numbers[i], new Intl.NumberFormat().format(numbers[i]));
  }

  return output;

};
